export const mail = {
  '站内信': '站內信',
  '返回': '返回',
  '有未读信息': '有{amount}條未讀資訊',
  '全部标记为已读': '全部標記為已讀',
  '隐藏已读消息': '隱藏已讀消息',
  '展开': '展開',
};


// WEBPACK FOOTER //
// ./src/i18n/lang/mail/tw.js